import { UploadPanel } from '../landing/UploadPanel'
import { RightPanel, WelcomeContent } from '../landing/WelcomePanel'
import { CloseIcon, FileIcon, UploadIcon } from '../icons'

interface LoadingScreenProps {
  files: File[]
  isProcessing: boolean
  loadingMessage: string
  onRemoveFile: (file: File) => void
  onConvert: () => void
}

/** Shows the chosen files, the Convert button, and the spinner while Claude reads the menu */
export const LoadingScreen = ({ files, isProcessing, loadingMessage, onRemoveFile, onConvert }: LoadingScreenProps) => (
  <div className="h-screen flex overflow-hidden relative">
    <UploadPanel>
      <div className="border-2 border-dashed border-gray-400 rounded-lg p-12 text-center bg-brand-secondary/20 backdrop-blur-sm">
        <div className="flex flex-col items-center">
          <UploadIcon />
          <h3 className="text-white text-lg font-medium mb-2">Your menu files</h3>
          <p className="text-gray-300 text-sm">Remove a file with the X, or convert when ready.</p>
        </div>
      </div>

      <div className="mt-4 space-y-2">
        {files.map((file, index) => (
          <div
            key={`${file.name}-${index}`}
            className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-3 flex items-center justify-between"
          >
            <div className="flex items-center space-x-3">
              <FileIcon />
              <div>
                <p className="text-sm font-medium text-white truncate">{file.name}</p>
                <p className="text-xs text-gray-400">{(file.size / 1024 / 1024).toFixed(2)}MB</p>
              </div>
            </div>
            <button
              onClick={() => onRemoveFile(file)}
              className="text-gray-400 hover:text-white"
              aria-label={`Remove ${file.name}`}
            >
              <CloseIcon className="h-5 w-5" />
            </button>
          </div>
        ))}
      </div>

      {!isProcessing && files.length > 0 && (
        <button
          onClick={onConvert}
          className="mt-4 w-full bg-white text-custom-dark rounded-lg py-3 font-medium hover:bg-gray-100 transition-colors"
        >
          {files.length === 1 ? 'Convert menu' : `Consolidate ${files.length} menus`}
        </button>
      )}
    </UploadPanel>

    <RightPanel>
      {isProcessing ? (
        <div className="text-center w-full">
          <div className="w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-xl font-medium text-custom-dark">{loadingMessage}</p>
        </div>
      ) : (
        <WelcomeContent />
      )}
    </RightPanel>
  </div>
)
